/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["h5[_ngcontent-%COMP%]{margin-top:0}  #summaries-table td{font-size:16px}#summaries-table[_ngcontent-%COMP%]{margin-top:.5rem;margin-bottom:.5rem}#summaries-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%]:first-child{text-align:left}#summaries-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(2){background-color:#6e6e6e}"];
export { styles as styles };

